import { render } from "./CarterBookNow.vue?vue&type=template&id=62bea3f2&scoped=true"
import script from "./CarterBookNow.vue?vue&type=script&lang=js"
export * from "./CarterBookNow.vue?vue&type=script&lang=js"

import "./CarterBookNow.vue?vue&type=style&index=0&id=62bea3f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bea3f2"]])

export default __exports__